/**
 * Define process before any other code runs (evita "process is not defined" en dependencias).
 * Debe importarse como primera línea en index.js.
 */
(function () {
	if (typeof process === "undefined") {
		var p = { env: { NODE_ENV: "development", PUBLIC_URL: "" } };
		if (typeof window !== "undefined") window.process = p;
		if (typeof global !== "undefined") global.process = p;
	}
})();
